import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { LorenAssetType } from "../interfaces/loren-asset-type.interface";
import { GenericItems } from "../../../shared/interfaces/generic-items.interface";
import { LorenAssetTypeService } from "../services/loren-asset-type-service/loren-asset-type.service";

@Injectable()
export class LorenAssetTypeResolver  {
  protected service = inject(LorenAssetTypeService);
  protected router = inject(Router);


  resolve(): Observable<LorenAssetType[]> {
    return this.service.query().pipe(
      map((dataItem: GenericItems<LorenAssetType>) => {
        return dataItem.items;
      })
    );
  }
}
